{
  "/help-images/mobile/connecting-station/03-mobile-connect.png": {
    "w": 750,
    "h": 1601
  },
  "/help-images/mobile/ecowitt-setup/03-mobile-setup.png": {
    "w": 750,
    "h": 1601
  },
  "/help-images/mobile/getting-started/03-station-dashboard.png": {
    "w": 750,
    "h": 1601
  },
  "/help-images/web/connecting-station/01-services-list.png": {
    "w": 1600,
    "h": 900
  },
  "/help-images/web/connecting-station/02-connect-button.png": {
    "w": 1280,
    "h": 420
  },
  "/help-images/web/ecowitt-setup/01-api-keys-form.png": {
    "w": 1280,
    "h": 916
  },
  "/help-images/web/ecowitt-setup/02-connected.png": {
    "w": 1280,
    "h": 426
  },
  "/help-images/web/getting-started/01-signup-form.png": {
    "w": 1600,
    "h": 718
  },
  "/help-images/web/getting-started/02-station-dashboard.png": {
    "w": 1600,
    "h": 900
  },
  "/help-images/web/netatmo-setup/01-connect.png": {
    "w": 1280,
    "h": 420
  },
  "/help-images/web/netatmo-setup/02-connected.png": {
    "w": 1280,
    "h": 346
  }
}
